<div class="flex flex-middle pos-relative">
    @for (option of options; track $index; let isFirst = $first) {
    <button class="flex flex-middle"
            [ngClass]="[isSelected(option) ? 'col-1' : 'col-4', isFirst ? 'm-r-3' : '']"
            type="button"
            [attr.aria-label]="'Switch to % columns' | translate : option.size"
            (click)="setState(option.size)">
        <i class="inline-flex"
           [ngClass]="'icon-grid-' + option.size"
           [style.font-size.px]="16"
           aria-hidden="true"></i>
    </button>
    }
</div>
